import moment from "moment";

const millisToMinutes = (millis) => Math.floor(millis / 60000);

// Validates that every configured reminder offset fits within the form's daily
// fill window, i.e. a reminder is not asked to fire earlier than the window in
// which the form can be filled.
//
// This only applies to DAILY schedules that have concrete time periods:
//   - "W ramach czasowych" (WINDOW) uses a date range + fill count and has no
//     daily fill window, so the check does not apply and always passes.
//   - No schedule / no time periods -> nothing to compare against -> passes.
//   - No reminders configured (empty or all blank offsets) -> passes.
//
// Returns true when the configuration is valid (safe to save).
export const remindersFitFillWindow = (schedule, timeBeforeEnd) => {
  if (
    !schedule ||
    schedule.scheduleType === "WINDOW" ||
    !schedule.timePeriods ||
    schedule.timePeriods.length === 0
  ) {
    return true;
  }

  const reminderOffsets = (timeBeforeEnd || [])
    .map((offset) => parseInt(offset, 10))
    .filter((offset) => !Number.isNaN(offset) && offset >= 1);
  if (reminderOffsets.length === 0) {
    return true;
  }

  let shortestFillWindow = Infinity;
  schedule.timePeriods.forEach((period) => {
    const duration = moment.duration(
      moment(period.endTime, "HH:mm").diff(moment(period.startTime, "HH:mm"))
    );
    const minutes = millisToMinutes(duration.asMilliseconds());
    if (!Number.isNaN(minutes) && minutes < shortestFillWindow) {
      shortestFillWindow = minutes;
    }
  });

  return !reminderOffsets.some((offset) => offset > shortestFillWindow);
};
